
import { fetchDataViewStandBy } from './_redux/dtpsCrud';
import StandardNew from '../../components/standartComponents/standardNew'
import { getUser} from '../../../index';

export default function DtpNew(props) {
      
  const newstd = {
    name: '',
    station: '',
    productActivity: '',
    alertProcedure: '',
    StructureId: null,
    standardType: "DTP",
    userId: getUser().id,
    status: true,
    version: 1,
      steps: [],
      trainingUsers: [],
    epis: [],
    tools: [],
    lpps: [],
    images: []
  }

  const defaultDadosBasicos = [
    {
      name: 'station',
      desc: 'Posto',
      class: 'col-4',
    },
    {
      name: 'productActivity',
      desc: 'Produto ou Tarefa',
      class: 'col-4',
    },
    {
      name: 'alertProcedure',
      desc: 'Procedimento de Alerta',
      class: 'col-4',
    },
  ]

    return StandardNew(defaultDadosBasicos, props, newstd, fetchDataViewStandBy, 'dtp');
}
